export const todayInMilliseconds = () => Date.now();
